import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PaymentOrderDetail  {
    _originalTypeClassName = "zERP.BO.PaymentOrderDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PaymentOrderDetail.translate = translateService;
}
this.Id = null;
this.Deductions = null;
this.Amount = null;
this.DeductionFor = null;
this.PayableAmount = null;
this.OtherPayments = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Deductions:any;
Amount:any;
DeductionFor:any;
PayableAmount:any;
OtherPayments:any;
SpendingRequestDetail:any;
PaymentOrderInvoice:any;
static setSpendingRequestDetail = ($this, value) => {
var oldValue = $this.SpendingRequestDetail;
$this.SpendingRequestDetail = value;
if (value != null) {
if (oldValue != null) {
Domain.SpendingRequestDetail.removePaymentOrderDetails(oldValue, $this);
}
Domain.SpendingRequestDetail.addPaymentOrderDetails(value, $this);
}
}
static setPaymentOrderInvoice = ($this, value) => {
var oldValue = $this.PaymentOrderInvoice;
$this.PaymentOrderInvoice = value;
if (value != null) {
if (oldValue != null) {
Domain.PaymentOrderInvoice.removeDetails(oldValue, $this);
}
Domain.PaymentOrderInvoice.addDetails(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}